/**
 * Classe que representa um nó da lista ligada contendo um valor HTML.
 */
export class HTMLElementNode {
    /** @type {string} */
    value;

    /** @type {HTMLElementNode | null} */
    next;

    /**
     * @param {string} value - O valor HTML ou texto que o nó contém.
     */
    constructor(value) {
        this.value = value;
        this.next = null;
    }
}



// WEBPACK FOOTER //
// ./src/mixins/html-writer/html-element-node.js